import CDAPromo from 'assets/promos/CDA.png'
import ClearAvmPromo from 'assets/promos/clearavm_promo.svg'
import ClearPropPromo from 'assets/promos/clearprop_promo.svg'
import HdiPromo from 'assets/promos/hdi_promo.svg'
import type {ChipProps} from 'components/Chip/Chip'
import type {ProductType} from 'types/orderTypes'

export const CLEARPROP = 'CLEARPROP'
export const CLEARAVM = 'CLEARAVM'
export const HDI = 'HDI'
export const CDA = 'CDA'
export const CDA_MLS = 'CDA_MLS'

export type ProductData = {
  title: string
  subtitle: string
  landingDescription: string
  popDescription: string
  learnMoreLink: string
  isProductActive: boolean
  icon: string
  price?: number
  minPrice?: number
  productColor: ChipProps['color']
  promoSvg: string
  chipLabel: string
  // to check if the product is available.
  // since now we only have 2 product, use only one flag to for simplicity.
  // if the logic gets complex later, change this to a isAvailable() function
  needPID?: boolean
}

const CDA_DATA: ProductData = {
  title: 'Collateral Desktop Analysis (CDA®)',
  subtitle: 'USPAP-compliant appraisal desktop review',
  landingDescription:
    'A USPAP-compliant appraisal desktop review that re-evaluates the original appraisal to enable pre-funding certainty.',
  popDescription:
    'Designed to remove pre-funding uncertainty, the CDA re-evaluates the original appraisal so you can deliver a comprehensive loan file.',
  learnMoreLink:
    'https://www.clearcapital.com/valuations/appraisal-products/collateral-desktop-analysis-cda/',
  isProductActive: true,
  icon: 'verified_user',
  productColor: 'cobalt',
  promoSvg: CDAPromo,
  chipLabel: 'CDA',
  minPrice: 90
}

export const productDataDictionary: {[key in ProductType]: ProductData} = {
  CLEARPROP: {
    title: 'ClearProp\u2122',
    subtitle: 'An interactive property analysis and valuation tool',
    landingDescription:
      'An interactive tool that brings data on a property together to quickly perform your own cost-effective valuations.',
    popDescription:
      'This comprehensive analytics tool brings all the data on a property together for you to quickly perform your own cost-effective valuations.',
    learnMoreLink: 'https://www.clearcapital.com/analytics/property-insight/clearprop/',
    isProductActive: true,
    icon: 'home',
    productColor: 'turquoise',
    promoSvg: ClearPropPromo,
    price: 15,
    chipLabel: 'ClearProp',
    needPID: true
  },
  CLEARAVM: {
    title: 'ClearAVM\u2122',
    subtitle: 'Instant property value insights',
    landingDescription:
      'A lending-grade automated valuation model with near-real-time data that provides an instant property value.',
    popDescription:
      'Our industry-leading, lending-grade automated valuation model (AVM) provides an extremely reliable and accurate prediction of market value, with nationwide coverage.',
    learnMoreLink: 'https://www.clearcapital.com/analytics/clear-avm/',
    isProductActive: false,
    icon: 'requestQuote',
    productColor: 'amethyst',
    promoSvg: ClearAvmPromo,
    chipLabel: 'ClearAVM'
  },
  HDI: {
    title: 'Home Data Index\u2122',
    subtitle: 'Quick access to real estate market knowledge',
    landingDescription:
      'A data-rich report that provides the most up-to-date housing market data from national to block levels.',
    popDescription:
      'A data-rich report that provides the most up-to-date housing market data from national to block levels.',
    learnMoreLink: 'https://www.clearcapital.com/analytics/home-data-index/',
    isProductActive: false,
    icon: 'public',
    productColor: 'cobalt',
    promoSvg: HdiPromo,
    chipLabel: 'HDI'
  },
  CDA: CDA_DATA,
  CDA_MLS: CDA_DATA
}

export const productTypeArray = [CLEARPROP, CDA] as const
